import { render, staticRenderFns } from "./alert-detail.vue?vue&type=template&id=5e1a47da&scoped=true&"
import script from "./alert-detail.vue?vue&type=script&lang=ts&"
export * from "./alert-detail.vue?vue&type=script&lang=ts&"
import style0 from "./alert-detail.vue?vue&type=style&index=0&id=5e1a47da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1a47da",
  null
  
)

export default component.exports